import TopTitle from "../components/TopTitle";
import Anaco from "../assets/img/iuta-anaco.png";

function History() {
  return (
    <div className="main-content">
      <TopTitle title="Historia" />
      <section className="bg-light">
        <div className="container">
          <div className="row align-items-center justify-content-center py-2">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <p className="py-2">
                La inquietud de un grupo de profesores de la Universidad Central de Venezuela, entre los que se
                cuentan los profesores José Luis Vegas Delgado, Ramón Alberto Yaguare y Néstor Arturo Gabaldón,
                gestan la creación de una Institución de educación superior en la ciudad de Anaco, Estado Anzoátegui,
                cuyo nombre inicial es Instituto Universitario de Tecnología de Administración Anzoátegui (IUTA),
                cambiando posteriormente a Instituto Universitario de Tecnología de Administración Industrial.
              </p>
              <p className="py-2">
                Fue creado mediante el decreto Nº 771 del 15 de febrero de 1990 (Gaceta Oficial Nº 34.411 del 15/02/1990), con
                la finalidad fundamental de formar los recursos humanos de alta calificación que necesita el desarrollo corporativo,
                mediante la formación integral de hombres y mujeres identificados con la problemática venezolana.
              </p>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12 text-center">
              <img src={Anaco} alt="IUTA Anaco" className="img-fluid" />
            </div>
          </div>
          <div className="row align-items-center justify-content-center py-2">
            <p className="py-2">
              El IUTA, busca satisfacer las necesidades de los programas de desarrollo requeridos en la región donde se establezca.
              En un tiempo relativamente corto y estimulado por el aumento de la demanda, responde a las exigencias del
              mercado proyectando la creación de otras sedes en Puerto la Cruz y en la Región Capital,
              creándose posteriormente Valencia y Maracay.
            </p>
            <p className="py-2">
              El 18 de octubre de 1991 nace el IUTA Extensión Puerto la Cruz, ubicada en la calle Maneiro de Puerto La Cruz,
              Estado Anzoátegui, a través de una publicación en Gaceta Oficial Nro. 34.823.
            </p>
            <p className="py-2">
              Posteriormente, con el aumento de la demanda en la zona norte del Estado Anzoátegui, se crea una Ampliación del
              IUTA Puerto la Cruz, ubicada en la calle Bolivar de la ciudad de Barcelona en el año 1992. Y unos años más tarde,
              en 1997, se crea la Ampliación Puerto Píritu del IUTA, en la calle La Planta, ubicada en la ciudad de
              Puerto Píritu, Estado Anzoátegui.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default History;
